import React from "react";
import { useExchangeRates } from "../context/ExchangeRateContext";

interface ToggleCurrencyProps {
  selectedCurrency: string;
  onToggle: (currency: string) => void;
}

const ToggleCurrency: React.FC<ToggleCurrencyProps> = ({ selectedCurrency, onToggle }) => {
  const isUSD = selectedCurrency === "USD";
  const { exchangeRates, lastUpdated } = useExchangeRates();

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    onToggle(isUSD ? "THB" : "USD");
  };

  return (
    <div className="flex flex-col items-center">
      {/* Toggle Switch - ปรับความกว้างลดลงเหลือ 84px */}
      <div
        className="relative flex items-center cursor-pointer select-none transition-all duration-300"
        style={{
          width: "84px", // ลดจาก 120px
          height: "26px", // ลดความสูงลงเล็กน้อยให้ดูเพรียว
          backgroundColor: "var(--button-userbox)",
          borderRadius: "100px",
          border: "1px solid var(--text-input)",
          padding: "2px", // เว้นระยะให้ตัวเลื่อนด้านใน
        }}
        onClick={handleClick}
      >
        {/* Background Labels */}
        <div className="absolute inset-0 flex w-full h-full text-[9px] font-bold">
          <div className="flex-1 flex items-center justify-center" style={{ color: "var(--secondary-text-color)" }}>
            THB
          </div>
          <div className="flex-1 flex items-center justify-center" style={{ color: "var(--secondary-text-color)" }}>
            USD
          </div>
        </div>

        {/* Sliding Active Box - ปรับขนาดให้พอดีกับ Track ใหม่ */}
        <div
          className="absolute flex items-center justify-center text-[9px] font-black transition-all duration-300 ease-in-out shadow-sm"
          style={{
            width: "40px", // ขนาดตัวเลื่อน
            height: "20px", 
            left: isUSD ? "calc(100% - 42px)" : "2px", // คำนวณตำแหน่งให้พอดีขอบ
            backgroundColor: isUSD ? "var(--currency-selected)" : "var(--green-btn)",
            borderRadius: "100px",
            color: "var(--text-black)",
            zIndex: 2,
          }}
        >
          {isUSD ? "USD" : "THB"}
        </div>
      </div>

      {/* Info Text - ปรับให้ชิดขึ้นและเล็กลง */}
      <div className="mt-1 text-center leading-tight">
        <p className="text-[9px] font-semibold" style={{ color: "var(--text-color)" }}>
          1 USD = {exchangeRates["THB"] ? exchangeRates["THB"].toFixed(3) : "-"} THB
        </p>
        <p className="text-[8px] opacity-70" style={{ color: "var(--text-color)" }}>
          {lastUpdated || "-"}
        </p>
      </div>
    </div>
  );
};

export default ToggleCurrency;